var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.contraer ? 'col-md-9 panel-main' : 'col-md-10 panel-main'},[_c('div',{staticClass:"row general"},[_c('div',{staticClass:"col-md-12"},[_c('iframe',{staticClass:"frame",attrs:{"src":_vm.data,"id":"frame"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }